import { ca } from '@cian/analytics';

type TParams = {
  chatId: string;
  withPhoto: boolean;
  opponentId?: number;
};

export function trackDeleteMessageSuccess({ chatId, withPhoto, opponentId }: TParams) {
  ca('eventSite', {
    action: 'Success_sopr',
    category: 'Chat',
    label: 'Delete_message',
    name: 'oldevent',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        with_photo: withPhoto,
        type: 'chat',
      },
    },
  });
}

//FIXME: будет позже
// export function trackDeleteFileSuccess({ chatId, opponentId }: TParams) {
//   ca('eventSite', {
//     action: 'Success_sopr',
//     category: 'Chat',
//     label: 'Delete_message',
//     name: 'oldevent',
//     page: {
//       extra: {
//         chat_id: chatId,
//         opponent_id: opponentId,
//         with_photo: true,
//         type: 'gallery',
//       },
//     },
//   });
// }
